var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.type != undefined && _vm.isMobileDevice() == false ? _vm.type.customStyle : ''),attrs:{"id":"site-upload-form"}},[(this.type != undefined)?_c('div',{attrs:{"id":"create-site-layer"}},[_c('div',{attrs:{"id":"vue-stepper"}},[_c('Questionnaire',{ref:"questionnaire",attrs:{"currentSection":0,"pinsActive":_vm.pinConfiguration.pinsActive,"pinCoords":_vm.pinCoordinates},on:{"registerPin":function () {
            _vm.registerMapInteraction(
              _vm.pinConfiguration.values.name,
              _vm.pinConfiguration.type,
              _vm.pinConfiguration.values.options,
              _vm.pinConfiguration.data
            );
          },"deRegisterPin":function () {
            _vm.deRegisterMapInteraction(
              _vm.pinConfiguration.name,
              _vm.pinConfiguration.type
            );
          },"setPinsActive":_vm.setPinsActive}})],1)]):_vm._e(),_c('div',{staticClass:"bottom-fixed"}),_c('MapKey')],1)}
var staticRenderFns = []

export { render, staticRenderFns }